/**
 * Navigation helpers — features collection + layout rows.
 */
import store from '@/store';

/** Parent sidebar groups (keep in sync with platform navigation-catalog.ts). */
export const NAVIGATION_GROUP_CATALOG_KEYS = [
  'activities',
  'userProjects',
  'ergebnisse',
  'administration',
];

export function isNavigationGroupCatalogKey(catalogKey) {
  return NAVIGATION_GROUP_CATALOG_KEYS.includes(catalogKey);
}

export function getFeaturesFromStore() {
  return store.getters['tenantContent/features'] || [];
}

export function isLayoutRowGroup(row) {
  if (isNavigationGroupCatalogKey(row?.catalogKey)) return true;
  return row?.itemKind === 'group';
}

export function buildRouteToCatalogKeyMap(features = getFeaturesFromStore()) {
  const entries = (features || [])
    .filter((f) => typeof f.route === 'string' && f.route && f.catalogKey)
    .map((f) => [f.catalogKey, f.route]);
  entries.sort((a, b) => b[1].length - a[1].length);
  return entries;
}

export function getCatalogKeyForRoute(path, features = getFeaturesFromStore()) {
  if (!path || typeof path !== 'string') return null;
  const normalized = path.split('?')[0];
  const routes = buildRouteToCatalogKeyMap(features);
  const matched = routes.find(([, route]) => (
    normalized === route || normalized.startsWith(`${route}/`)
  ));
  return matched ? matched[0] : null;
}
